import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IAlcoholDrivingDetail, IAlcoholDrivingSearchFields, alcoholDrivingService } from './alcoholDrivingService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { globalPrompt } from '@/components/message'
import { ModoulTypeList } from '@/types/TcoDs'
import { message } from 'antd'
import { convertRes2Blob } from '@/utils/exportFile'

export const threeInspectionAlcoholDrivingModel = createModel(function () {
    const {
        user: { shopCode, createUser, userType, dealerName },
    } = useGlobalModel(({ user }) => [user])

    const settingTypeList = ModoulTypeList
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IAlcoholDrivingDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IAlcoholDrivingSearchFields>({ createUser: userType === '超级管理员' ? '' : createUser })
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IAlcoholDrivingDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IAlcoholDrivingDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IAlcoholDrivingDetail[]>([])
    const [SelectedId, setSelectedId] = useState('')
    //对账明细打开页面
    const [detailVisible, setDetailVisible] = useState(false)
    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    //对账明细打开页面
    const [addCarVisible, setAddCarVisible] = useState(false)
    const [editCarVisible, setEditCarVisible] = useState<any>({
        visible: false,
        value: {},
    })

    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>({})
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: IAlcoholDrivingSearchFields = searchParam) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            createUserId: shopCode,
            alcoholTesting: 'YES',
            // fleet: userType === '管理员' ? createUser : undefined,
            // retrieveName: userType === '司机' || userType === '押运员' ? createUser : undefined,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            createUser: userType === '超级管理员' ? searchValue.createUser : createUser,
            dealerName: dealerName || undefined,
            // departureEndTime:getCurrentDateTime()
        }
        let { retData } = await alcoholDrivingService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        records.forEach((record) => {
            const { driverName, escortName, alcoholTestingRecordsVoList } = record
            const namesToCheck = [driverName, escortName].filter((name) => name) // 过滤掉空字符串

            namesToCheck.forEach((name) => {
                const hasName = alcoholTestingRecordsVoList.some((detection: any) => detection.driverName === name)
                if (!hasName) {
                    if ((searchValue.retrieveName && name.includes(searchValue.retrieveName)) || !searchValue.retrieveName) {
                        alcoholTestingRecordsVoList.push({ driverName: name })
                    }
                    // 如果缺少该名字，则添加一个新的对象到alcoholDetectionVos数组
                }
            })
        })
        // setPgCfg(transPgToPagination({ total: records.length, size: 100, current: 1 }))
        setDataSource(records)
        // let { retData: totalList } = await alcoholDrivingService.getTotal(shopCode)
        // setTotalNum(totalList)
        setLoading(false)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IAlcoholDrivingSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }
    //删除排班
    const sendNotifications = () => {
        globalPrompt('modal', {
            title: '发送通知',
            type: 'warning',
            text: '您已排班完成发送通知？',
            okText: '确认',
            onOk: async () => {
                let notifications = await alcoholDrivingService.sendNotifications({ createUserId: shopCode })
                if (notifications.success) {
                    message.success('发送成功!')
                } else {
                    message.success('发送失败!' + notifications.retMsg)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    //导出
    const exportListData = async () => {
        let ids: any = ''
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            ids = selectedRowKeys.map((item) => item.id as string).toString()
        }
        try {
            const searchParams = {
                ...searchParam,
                createUserId: shopCode,
                alcoholTesting: 'YES',
                pageSize: -1,
                pageNum: 1,
                ids: ids ? ids : '',
                dealerName: dealerName || undefined,
            }
            let result = await alcoholDrivingService.exportList(searchParams)
            convertRes2Blob(result)
        } catch {
            message.error('导出失败')
        }
    }
    //删除排班
    const onDelete = (record: IAlcoholDrivingDetail) => {
        globalPrompt('modal', {
            title: '删除排班',
            type: 'warning',
            text: '您正在删除排班是否确认删除？',
            okText: '确认',
            onOk: async () => {
                let list = record.map((item) => {
                    return { id: item.id }
                })
                let insertRet = await alcoholDrivingService.onDelete(list)
                if (insertRet.success) {
                    message.success('删除成功!')
                } else {
                    message.success('删除失败!' + insertRet.retMsg)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        detailEditForm,
        detailAddForm,
        mode,
        SelectedId,
        settingTypeList,
        totalNum,
        loading,
        addCarVisible,
        editCarVisible,
        /***method***/
        setEditCarVisible,
        setAddCarVisible,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setMode,
        setSelectedId,
        onDelete,
        sendNotifications,
        exportListData,
    }
})
